import React from "react";
import ColumnGuideDialog from "../../../../library/Dialog/ColumnGuideDialog";
import { getCaColumnGuide } from "./utils/columnGuide";

const ColumnInfo = ({
  infoOpen,
  setInfoOpen,
  caType,
  caSettings,
  isHirePurchase = false,
}) => (
  <ColumnGuideDialog
    open={infoOpen}
    onClose={() => setInfoOpen(false)}
    title={`${caType} column guide`}
    description={
      isHirePurchase
        ? "Understand the columns and claim calculations in this Hire Purchase schedule."
        : "Understand the columns and claim calculations for current and prior YA assets."
    }
    contextKey={`${caType}-${isHirePurchase ? "hp" : "ya"}`}
    columns={getCaColumnGuide(caType, caSettings, isHirePurchase)}
  />
);

export default ColumnInfo;
